export function updateMachine(data) {
    let { updateMachineRequest, updateMachineError, updateMachineResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'update_machine',
        this.createBundle('update_machine', { machine: data }, this.POST, updateMachineRequest, updateMachineResult, updateMachineError)
    )
}
